import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Login';
import PublicRouters from './PublicRouters';
import PrivateRouters from './PrivateRouters';
import Dashboard from "../Components/Dashboard";
import Customer from "../Components/Customer"
import CustomerList from "../Components/Customer/List"
import CustomerAdd from "../Components/Customer/Register"
import CustomerView from "../Components/Customer/View"
import MSDCustomer from "../Components/MSDCustomer"
import MSDCustomerList from "../Components/MSDCustomer/List"
import MSDCustomerAdd from "../Components/MSDCustomer/Register"
import MSDCustomerView from "../Components/MSDCustomer/View"
import CustomerProof from "../Components/Customer/Proof"
import Car from "../Components/Car"
import CarList from "../Components/Car/List"
import CarAdd from "../Components/Car/Add"
import CarView from "../Components/Car/View"
import CarEdit from "../Components/Car/Edit"
import CarEvent from "../Components/Car/Booking"
import Subadmin from "../Components/Subadmin/index"
import SubadminList from "../Components/Subadmin/List"
import SubadminAdd from "../Components/Subadmin/Add"
import SubadminView from "../Components/Subadmin/View"
import OldCustomer from "../Components/OldCustomer"
import Booking from '../Components/Booking';
import BookingList from '../Components/Booking/List';
import Booked from '../Components/Booking/Booked';
import Delivery from '../Components/Booking/Delivery';
import Availability from '../Components/Car/Availability';
import Report from '../Components/Subadmin/Report';
import Pending from '../Components/Booking/Pending';
import Complete from "../Components/Booking/Complete"
import BookingView from "../Components/Booking/View"
import EditInvoice from '../Components/Booking/EditInvoice';
import Revenue from '../Components/Revenue';
import Lead from "../Components/Lead"
import LeadView from "../Components/Lead/View"
import Call from "../Components/Call"
import Request from '../Components/Request';
import Verification from '../Components/Booking/Verification';
import DailyReport from '../Components/Report'
import { useAuth } from '../Contexts/AuthenticateProvider';
import Download from '../Components/Download'
import DownloadCustomer from '../Components/Download/Customer'
import DownloadBooking from '../Components/Download/Booking'
import DownloadLeads from '../Components/Download/Lead'
import DownloadCalls from '../Components/Download/Call'
import AdminDashboard from "../Components/AdminDashboard"
import ReqData from '../Components/ReqData'
import ReqDataView from '../Components/ReqData/View'
import ReqDataList from '../Components/ReqData/List'
import { getCookie } from '../Helpers/Utils';
import SiteCustomer from '../Components/SiteCustomer'

const Index = () => {
  const { userDetails } = useAuth()
  const person = getCookie('person')
  return (
    <React.Fragment>
      <Router>
        <Routes>
          <Route element={<PublicRouters />}>
            <Route path="/login" element={<Login />} />
            <Route path='/*' element={<Navigate to="/login" />} />
          </Route>
          <Route element={<PrivateRouters />}>
            <Route path="/" element={userDetails?.name ? userDetails?.adminId ? <AdminDashboard /> : <Dashboard /> : <></>} />
            <Route path="/old-cust/:pageNo" element={<OldCustomer />} />
            <Route path="/revenue/:pageNo" element={<Revenue />} />
            <Route path="/site-customer/:pageNo" element={<SiteCustomer />} />
            <Route path='customer' element={<Customer />}>
              <Route path='*' element={<CustomerList />} />
              <Route path=':pageNo' element={<CustomerList />} />
              <Route path='register' element={<CustomerAdd />} />
              <Route path='update/:id' element={<CustomerAdd />} />
              <Route path='booking/update/:id/:bookingId' element={<CustomerAdd />} />
              <Route path='edit/:id/:steps' element={<CustomerAdd />} />
              <Route path='view/:customerId' element={<CustomerView />} />
              <Route path='proof/:customerId' element={<CustomerProof />} />
              <Route index element={<Navigate to="/customer/1" />} />
            </Route>
            <Route path='req-data' element={<ReqData />}>
              <Route path='*' element={<ReqDataList />} />
              <Route path=':pageNo' element={<ReqDataList />} />
              <Route path='view/:id' element={<ReqDataView />} />
              <Route index element={<Navigate to="/req-data/1" />} />
            </Route>
            {/* <Route path='msd' element={<MSDCustomer />}>
              <Route path='*' element={<MSDCustomerList />} />
              <Route path=':pageNo' element={<MSDCustomerList />} />
              <Route path='update/:id' element={<MSDCustomerAdd />} />
              <Route path='view/:customerId' element={<MSDCustomerView />} />
              <Route index element={<Navigate to="/msd/1" />} />
            </Route> */}
            <Route path='booking' element={<Booking />}>
              <Route path='*' element={<BookingList />} />
              <Route path=':pageNo' element={<BookingList />} />
              <Route path='register' element={<Booked />} />
              <Route path='update/:id' element={<Booked />} />
              <Route path='delivery/:id' element={<Delivery />} />
              <Route path='pending/:id' element={<Pending />} />
              <Route path='close/:id' element={<Complete />} />
              <Route path='invoice/:id' element={<EditInvoice />} />
              <Route path='view/:id' element={<BookingView />} />
              <Route path='verify/:id' element={<Verification />} />
              <Route index element={<Navigate to="/booking/1" />} />
            </Route>
            <Route path='car' element={<Car />}>
              <Route path='*' element={<CarList />} />
              <Route path=':pageNo' element={<CarList />} />
              <Route path='register' element={<CarAdd />} />
              <Route path='view/:id' element={<CarView />} />
              <Route path='events/:id' element={<CarEvent />} />
              <Route path='availability' element={<Availability />} />
              <Route path='update/:id' element={<CarEdit />} />
              <Route index element={<Navigate to="/car/1" />} />
            </Route>
            <Route path='subadmin' element={<Subadmin />}>
              <Route path='*' element={<SubadminList />} />
              <Route path=':pageNo' element={<SubadminList />} />
              <Route path='register' element={<SubadminAdd />} />
              <Route path='report/:id' element={<Report />} />
              <Route path='view/:id' element={<SubadminView />} />
              <Route index element={<Navigate to="/subadmin/1" />} />
            </Route>
            <Route path="report" element={<Report />} />
            <Route path="daily/report/:pageNo" element={<DailyReport />} />
            <Route path="request/:status/:pageNo" element={<Request />} />
            <Route path="lead/:active/:pageNo" element={<Lead />} />
            <Route path="lead/:leadId" element={<LeadView />} />
            <Route path="call/:active/:pageNo" element={<Call />} />
            <Route path='/*' element={<Navigate to="/" />} />
            <Route path='download' element={<Download />}>
              <Route path='*' element={<Navigate to={`/download/cust/1`} />} />
              <Route index element={<Navigate to="/download/cust/1" />} />
              <Route path="cust/:pageNo" element={<DownloadCustomer />} />
              <Route path="book/:pageNo" element={<DownloadBooking />} />
              <Route path="calls/:pageNo" element={<DownloadCalls />} />
              <Route path="leads/:pageNo" element={<DownloadLeads />} />
            </Route>
          </Route>
        </Routes>
      </Router>

    </React.Fragment>
  )
}

export default Index
